function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons / Copy");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M31.5789474,8 L11.3684211,8 C9.50736842,8 8,9.46454545 8,11.2727273 L8,34.1818182 L11.3684211,34.1818182 L11.3684211,11.2727273 L31.5789474,11.2727273 L31.5789474,8 Z M36.6315789,14.5454545 L18.1052632,14.5454545 C16.2442105,14.5454545 14.7368421,16.01 14.7368421,17.8181818 L14.7368421,40.7272727 C14.7368421,42.5354545 16.2442105,44 18.1052632,44 L36.6315789,44 C38.4926316,44 40,42.5354545 40,40.7272727 L40,17.8181818 C40,16.01 38.4926316,14.5454545 36.6315789,14.5454545 Z M36.6315789,40.7272727 L18.1052632,40.7272727 L18.1052632,17.8181818 L36.6315789,17.8181818 L36.6315789,40.7272727 Z",
  id: "path-1"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Copy",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Colors-/-Brand-/-Brewmaster-/-_Main",
  mask: "url(#mask-2)",
  fill: "#008EFF"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.000000, 24.000000) rotate(-270.000000) translate(-24.000000, -24.000000) translate(-0.000000, -0.000000)",
  id: "Color"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "0 0 48 0 48 48 0 48"
}))));

var SvgCopyIcon = function SvgCopyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy-icon.5b8ceb25.svg";
export { ForwardRef as ReactComponent };